export interface IUser {
  id?: string
  firstName?: string
  lastName?: string
  email?: string
  city?: string
  state?: string
  title?: string
  avatar?: string
  status?: string
  company?: string
  country?: string
  phoneNumber?: string
  createdAt?: string
  updatedAt?: string
  // can revisit this but our users
  // are currently way to dynamic between events
  [key: string]: unknown
}

export enum UserStatus {
  ONLINE = 'Online',
  OFFLINE = 'Offline'
}
